import { coreInitiativesLinksAddSyncSlice } from './add';
import { CoreInitiativesLinksName } from './name';
import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postInitiativeLink } from '@api';

export const coreInitiativesLinksPostAsyncSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [ coreInitiativesLinksAddSyncSlice.syncActionCreator ]
	},
	name: CoreInitiativesLinksName,
	receive: true,
	request: true,
	requestHandler: postInitiativeLink
});
